import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_BHBHA = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_BHBHA' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'></p>
                <p className='w-750'></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>LOCUS</span>
                            <input type='text' id='txtLocus' name='txtLocus' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>LONI</span>
                            <input type='text' id='txtLoni' name='txtLoni' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary Diagnosis (DSM-5/ICD-10)</span>
                            <input type='text' id='txtPrimaryDx' name='txtPrimaryDx' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h2>Behavioral Health History</h2></p>

                <p className='w-750'>
                    <span className='eleHeader'>Chief Complaint</span>
                    <span className='small'>Major symptoms, difficulties, and/or Issues as they relate to behavioral health in recipient's own words/quoted.</span>
                    <textarea id='txtChiefComplaint' name='txtChiefComplaint' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem/History of Present Illness</span>
                    <span className='small'>(Including recipient's reason for seeking services, precipitating factors, symptoms, behavioral and functioning impacts, onset/course of issues, current behavioral health providers, services sought and recipient expectation.)</span>
                    <textarea id='txtPresentProblem' name='txtPresentProblem' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Behavioral Health Provider Name</span>
                            <input type='text' id='txtCurrentBxProvider' name='txtCurrentBxProvider' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type='text' id='txtCurrentBxProviderPhone' name='txtCurrentBxProviderPhone' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Past Psychiatric History - Outpatient</span>
                    <input type='checkbox' id='cb3_Outpatient' name='cb3_Outpatient' className='add-only' value='None' /> None<br />
                    <textarea id='txtPastPsychHx' name='txtPastPsychHx' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Past Psychiatric History - Hospitalizations</span>
                    <input type='checkbox' id='cb3_Inpatient' name='cb3_Inpatient' className='add-only' value='None' /> None<br />
                    <textarea id='txtPastPsychHx_Hosp' name='txtPastPsychHx_Hosp' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional History/Comments</span>
                    <textarea id='txtAdditionalHx' name='txtAdditionalHx' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Substance Abuse/Dependence</h2></p>

                <p className='w-750'><input type='checkbox' id='cb_SubsAbuse' name='cb_SubsAbuse' className='add-only' value='None' /> None</p>

                <p className='w-750'><h5>(Past use of primary, secondary & tertiary current substance, incl. type, freq, method & age of 1st use.)</h5></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Check any/all that apply in last 12 months</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSa_1' name='cbSa_1' className='add-only' value='AlcoholUse' /> Alcohol Use</td>
                        <td className='w-250'><input type='checkbox' id='cbSa_2' name='cbSa_2' className='add-only' value='IllegalDrugUse' /> Illegal Drug Use</td>
                        <td className='w-250'><input type='checkbox' id='cbSa_3' name='cbSa_3' className='add-only' value='InjectedDrugUse' /> Injected Drug Use</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSa_4' name='cbSa_4' className='add-only' value='TobaccoProductUse' /> Tobacco Product Use</td>
                        <td className='w-250'><input type='checkbox' id='cbSa_5' name='cbSa_5' className='add-only' value='PrescriptionDrugsAbuse' /> Prescription Drugs Abuse</td>
                        <td className='w-250'><input type='checkbox' id='cbSa_6' name='cbSa_6' className='add-only' value='NonPrescriptionAbuse' /> Non-Prescription (OTC) abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSa_7' name='cbSa_7' className='add-only' value='AlcoholDrugOverdose' /> Alcohol and/or Drug Overdose</td>
                        <td className='w-250'><input type='checkbox' id='cbSa_8' name='cbSa_8' className='add-only' value='AlcoholDrugWithdrawal' /> Alcohol and/or Drug Withdrawal</td>
                        <td className='w-250'><input type='checkbox' id='cbSa_9' name='cbSa_9' className='add-only' value='ProblemsCauseGambling' /> Problems Cause by Gambling</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSa_10' name='cbSa_10' className='add-only' value='TroubleStoppingAnySubstance' /> Trouble Stopping Any Substance</td>
                        <td className='w-250'><input type='checkbox' id='cbSa_11' name='cbSa_11' className='add-only' value='CaffeineUse' /> Caffeine Use</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSa_12' name='cbSa_12' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtSa_12' name='txtSa_12' className='add-only w-350 custom-add-only'></input>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Substance Abuse Treatment History</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSatxHx_1' name='cbSatxHx_1' className='add-only' value='None' /> None</td>
                        <td className='w-250'><input type='checkbox' id='cbSatxHx_2' name='cbSatxHx_2' className='add-only' value='Outpatient' /> Outpatient</td>
                        <td className='w-250'><input type='checkbox' id='cbSatxHx_3' name='cbSatxHx_3' className='add-only' value='IntensiveOutpatient' /> Intensive Outpatient</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSatxHx_4' name='cbSatxHx_4' className='add-only' value='ResidentialInpatient' /> Residential/Inpatient</td>
                        <td className='w-250'><input type='checkbox' id='cbSatxHx_5' name='cbSatxHx_5' className='add-only' value='Detox' /> Detox</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSatxHx_6' name='cbSatxHx_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtSaTxHx_6' name='txtSaTxHx_6' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>SUBSTANCE TYPE<br />Include all used in last 30 days</span></td>
                        <td className='w-75'><span className='eleHeader'>AGE OF<br />1ST USE</span></td>
                        <td className='w-75'><span className='eleHeader'>YEARS IN<br />LIFETIME</span></td>
                        <td className='w-75'><span className='eleHeader'>DAYS IN<br />PAST 30</span></td>
                        <td className='w-75'><span className='eleHeader'>DAYS SINCE<br />LAST USE</span></td>
                        <td className='w-100'><span className='eleHeader'>AMOUNT</span></td>
                        <td className='w-200'><span className='eleHeader'>ROUTE OF ADMIN</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSa_1_1' name='txtSa_1_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_1_2' name='txtSa_1_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_1_3' name='txtSa_1_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_1_4' name='txtSa_1_4' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_1_5' name='txtSa_1_5' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtSa_1_6' name='txtSa_1_6' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSa_1_7' name='cbSa_1_7' className='add-only' value='Oral' /> Oral &nbsp;
                            <input type='checkbox' id='cbSa_1_8' name='cbSa_1_8' className='add-only' value='Nasal' /> Nasal &nbsp;
                            <input type='checkbox' id='cbSa_1_9' name='cbSa_1_9' className='add-only' value='Smoke' /> Smoke &nbsp;
                            <input type='checkbox' id='cbSa_1_10' name='cbSa_1_10' className='add-only' value='NonIvInj' /> Non-IV Inj &nbsp;
                            <input type='checkbox' id='cbSa_1_11' name='cbSa_1_11' className='add-only' value='Iv' /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSa_2_1' name='txtSa_2_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_2_2' name='txtSa_2_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_2_3' name='txtSa_2_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_2_4' name='txtSa_2_4' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_2_5' name='txtSa_2_5' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtSa_2_6' name='txtSa_2_6' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSa_2_7' name='cbSa_2_7' className='add-only' value='Oral' /> Oral &nbsp;
                            <input type='checkbox' id='cbSa_2_8' name='cbSa_2_8' className='add-only' value='Nasal' /> Nasal &nbsp;
                            <input type='checkbox' id='cbSa_2_9' name='cbSa_2_9' className='add-only' value='Smoke' /> Smoke &nbsp;
                            <input type='checkbox' id='cbSa_2_10' name='cbSa_2_10' className='add-only' value='NonIvInj' /> Non-IV Inj &nbsp;
                            <input type='checkbox' id='cbSa_2_11' name='cbSa_2_11' className='add-only' value='Iv' /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSa_3_1' name='txtSa_3_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_3_2' name='txtSa_3_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_3_3' name='txtSa_3_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_3_4' name='txtSa_3_4' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_3_5' name='txtSa_3_5' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtSa_3_6' name='txtSa_3_6' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSa_3_7' name='cbSa_3_7' className='add-only' value='Oral' /> Oral &nbsp;
                            <input type='checkbox' id='cbSa_3_8' name='cbSa_3_8' className='add-only' value='Nasal' /> Nasal &nbsp;
                            <input type='checkbox' id='cbSa_3_9' name='cbSa_3_9' className='add-only' value='Smoke' /> Smoke &nbsp;
                            <input type='checkbox' id='cbSa_3_10' name='cbSa_3_10' className='add-only' value='NonIvInj' /> Non-IV Inj &nbsp;
                            <input type='checkbox' id='cbSa_3_11' name='cbSa_3_11' className='add-only' value='Iv' /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSa_4_1' name='txtSa_4_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_4_2' name='txtSa_4_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_4_3' name='txtSa_4_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_4_4' name='txtSa_4_4' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_4_5' name='txtSa_4_5' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtSa_4_6' name='txtSa_4_6' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSa_4_7' name='cbSa_4_7' className='add-only' value='Oral' /> Oral &nbsp;
                            <input type='checkbox' id='cbSa_4_8' name='cbSa_4_8' className='add-only' value='Nasal' /> Nasal &nbsp;
                            <input type='checkbox' id='cbSa_4_9' name='cbSa_4_9' className='add-only' value='Smoke' /> Smoke &nbsp;
                            <input type='checkbox' id='cbSa_4_10' name='cbSa_4_10' className='add-only' value='NonIvInj' /> Non-IV Inj &nbsp;
                            <input type='checkbox' id='cbSa_4_11' name='cbSa_4_11' className='add-only' value='Iv' /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSa_5_1' name='txtSa_5_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_5_2' name='txtSa_5_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_5_3' name='txtSa_5_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_5_4' name='txtSa_5_4' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtSa_5_5' name='txtSa_5_5' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtSa_5_6' name='txtSa_5_6' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSa_5_7' name='cbSa_5_7' className='add-only' value='Oral' /> Oral &nbsp;
                            <input type='checkbox' id='cbSa_5_8' name='cbSa_5_8' className='add-only' value='Nasal' /> Nasal &nbsp;
                            <input type='checkbox' id='cbSa_5_9' name='cbSa_5_9' className='add-only' value='Smoke' /> Smoke &nbsp;
                            <input type='checkbox' id='cbSa_5_10' name='cbSa_5_10' className='add-only' value='NonIvInj' /> Non-IV Inj &nbsp;
                            <input type='checkbox' id='cbSa_5_11' name='cbSa_5_11' className='add-only' value='Iv' /> IV
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h2>Physical</h2></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Medical Conditions</span>
                            <span className='small'>Check all that apply.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPhys_1' name='cbPhys' className='add-only' value='Pregnant' /> Pregnant</td>
                        <td className='w-250'>Due Date: <input type='date' id='txtPhys_2' name='txtPhys_2' className='add-only w-150 custom-add-only' /></td>
                        <td className='w-250'>Prenatal Care: <input type='text' id='txtPhys_3' name='txtPhys_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPhys_4' name='cbPhys_4' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_5' name='cbPhys_5' className='add-only' value='CongestiveHeartFailure' /> Congestive Heart Failure</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_6' name='cbPhys_6' className='add-only' value='Asthma' /> Asthma</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPhys_7' name='cbPhys_7' className='add-only' value='Seizure' /> Seizure</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_8' name='cbPhys_8' className='add-only' value='Cancer' /> Cancer</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_9' name='cbPhys_9' className='add-only' value='Underweight' /> Underweight</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPhys_10' name='cbPhys_10' className='add-only' value='HighBloodPressure' /> High Blood Pressure</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_11' name='cbPhys_11' className='add-only' value='Stroke' /> Stroke</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_12' name='cbPhys_12' className='add-only' value='Emphysema' /> Emphysema</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPhys_13' name='cbPhys_13' className='add-only' value='Cirrhosis' /> Cirrhosis</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_14' name='cbPhys_14' className='add-only' value='ChronicPain' /> Chronic Pain</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_15' name='cbPhys_15' className='add-only' value='Overweight' /> Overweight</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPhys_16' name='cbPhys_16' className='add-only' value='HeartDisease' /> Heart Disease</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_17' name='cbPhys_17' className='add-only' value='Diabetes' /> Diabetes</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_18' name='cbPhys_18' className='add-only' value='Epilepsy' /> Epilepsy</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPhys_19' name='cbPhys_19' className='add-only' value='DigestiveProblems' /> Digestive Problems</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_20' name='cbPhys_20' className='add-only' value='ThyroidDisease' /> Thyroid Disease</td>
                        <td className='w-250'><input type='checkbox' id='cbPhys_21' name='cbPhys_21' className='add-only' value='Std' /> STD</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPhys_22' name='cbPhys_22' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtPhys_23' name='txtPhys_23' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Current and Past Medications</h3></p>
                <p className='w-750'><h5>Including non-psychotropic medications</h5></p>

                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-75'><span className='eleHeader'>Dose</span></td>
                        <td className='w-75'><span className='eleHeader'>Freq</span></td>
                        <td className='w-75'><span className='eleHeader'>Route</span></td>
                        <td className='w-75'><span className='eleHeader'>Current</span></td>
                        <td className='w-250'><span className='eleHeader'>Comments (Reason Prescribed/Response, etc)</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_1_1' name='txtMed_1_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_1_2' name='txtMed_1_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_1_3' name='txtMed_1_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_1_4' name='txtMed_1_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_1_5' name='ddlMed_1_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_1_6' name='txtMed_1_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_2_1' name='txtMed_2_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_2_2' name='txtMed_2_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_2_3' name='txtMed_2_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_2_4' name='txtMed_2_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_2_5' name='ddlMed_2_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_2_6' name='txtMed_2_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_3_1' name='txtMed_3_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_3_2' name='txtMed_3_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_3_3' name='txtMed_3_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_3_4' name='txtMed_3_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_3_5' name='ddlMed_3_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_3_6' name='txtMed_3_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_4_1' name='txtMed_4_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_4_2' name='txtMed_4_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_4_3' name='txtMed_4_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_4_4' name='txtMed_4_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_4_5' name='ddlMed_4_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_4_6' name='txtMed_4_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_5_1' name='txtMed_5_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_5_2' name='txtMed_5_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_5_3' name='txtMed_5_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_5_4' name='txtMed_5_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_5_5' name='ddlMed_5_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_5_6' name='txtMed_5_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_6_1' name='txtMed_6_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_6_2' name='txtMed_6_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_6_3' name='txtMed_6_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_6_4' name='txtMed_6_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_6_5' name='ddlMed_6_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_6_6' name='txtMed_6_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_7_1' name='txtMed_7_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_7_2' name='txtMed_7_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_7_3' name='txtMed_7_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_7_4' name='txtMed_7_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_7_5' name='ddlMed_7_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_7_6' name='txtMed_7_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_8_1' name='txtMed_8_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_8_2' name='txtMed_8_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_8_3' name='txtMed_8_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_8_4' name='txtMed_8_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_8_5' name='ddlMed_8_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_8_6' name='txtMed_8_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_9_1' name='txtMed_9_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_9_2' name='txtMed_9_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_9_3' name='txtMed_9_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_9_4' name='txtMed_9_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_9_5' name='ddlMed_9_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_9_6' name='txtMed_9_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtMed_10_1' name='txtMed_10_1' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_10_2' name='txtMed_10_2' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_10_3' name='txtMed_10_3' className='add-only' /></td>
                        <td className='w-75'><input type='text' id='txtMed_10_4' name='txtMed_10_4' className='add-only' /></td>
                        <td className='w-75'>
                            <select id='ddlMed_10_5' name='ddlMed_10_5' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id='txtMed_10_6' name='txtMed_10_6' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Allergies</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='radio' id='rbAllergiesNone' name='rbAllergies' className='add-only' value='NoReportedDrugFoodAllergies' /> No Reported Drug or Food Allergies;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAllergiesOther' name='rbAllergies' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtAllergiesOther' name='txtAllergiesOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Care Physican</span>
                            <input type='text' id='txtPCP' name='txtPCP' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                            <input type='text' id='txtPCPPhone' name='txtPCPPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Fax</span>
                            <input type='text' id='txtPCPFax' name='txtPCPFax' className='add-only' />
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Medical History</span>
                    <span className='small'>(Diagnosis, Hospitalizations, Surgery, labs values, status of conditions, etc.)</span>
                    <textarea id='txtAdditionalMedHx' name='txtAdditionalMedHx' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Social</h2></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current Legal Status</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbLegal_1' name='cbLegal_1' className='add-only' value='None' /> None</td>
                        <td className='w-250'><input type='checkbox' id='cbLegal_2' name='cbLegal_2' className='add-only' value='Parole' /> Parole</td>
                        <td className='w-250'><input type='checkbox' id='cbLegal_3' name='cbLegal_3' className='add-only' value='Probation' /> Probation</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbLegal_4' name='cbLegal_4' className='add-only' value='ChargesPending' /> Charges Pending</td>
                        <td className='w-500'><input type='checkbox' id='cbLegal_5' name='cbLegal_5' className='add-only' value='CourtOrderedOutpatientTreatment;' /> Court-Ordered Outpatient Treatment</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbLegal_6' name='cbLegal_6' className='add-only' value='Aot' /> AOT</td>
                        <td className='w-250'><input type='checkbox' id='cbLegal_7' name='cbLegal_7' className='add-only' value='Judicial' /> Judicial</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbLegal_8' name='cbLegal_8' className='add-only' value='Other' /> Other</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comment/Detail</span>
                    <textarea id='txtLegal_Comment' name='txtLegal_Comment' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Past Legal Status</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPastLegal_1' name='cbPastLegal_1' className='add-only' value='None' /> None</td>
                        <td className='w-250'><input type='checkbox' id='cbPastLegal_2' name='cbPastLegal_2' className='add-only' value='Dwi' /> DWI</td>
                        <td className='w-250'><input type='checkbox' id='cbPastLegal_3' name='cbPastLegal_3' className='add-only' value='PriorArrests' /> Prior Arrests</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPastLegal_4' name='cbPastLegal_4' className='add-only' value='PriorIncarcerations' /> Prior Incarcerations</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPastLegal_5' name='cbPastLegal_5' className='add-only' value='Other' /> Other</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comment/Detail</span>
                    <textarea id='txtPastLegal_Comment' name='txtPastLegal_Comment' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Family History</h4></p>
                <p className='w-750'><h5>(relationship status with relatives, family involvement in treatment, and living status of significant relatives)</h5></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Custodial Status</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCustodial_1' name='cbCustodial_1' className='add-only' value='IndependentAdult' /> Independent Adult</td>
                        <td className='w-250'><input type='checkbox' id='cbCustodial_2' name='cbCustodial_2' className='add-only' value='BiologicFather' /> Biologic Father</td>
                        <td className='w-250'><input type='checkbox' id='cbCustodial_3' name='cbCustodial_3' className='add-only' value='BiologicMother' /> Biologic Mother</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCustodial_4' name='cbCustodial_4' className='add-only' value='JointBiologicParents' /> Joint Biologic Parents</td>
                        <td className='w-250'><input type='checkbox' id='cbCustodial_5' name='cbCustodial_5' className='add-only' value='GovtJudicial' /> Gov't/Judicial</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPastLegal_6' name='cbCustodial_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtPastLegal_Other' name='txtPastLegal_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Name</span>
                            <input type='text' id='txtContactName' name='txtContactName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Relation</span>
                            <input type='text' id='txtContactRelation' name='txtContactRelation' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Phone</span>
                            <input type='text' id='txtContactPhone' name='txtContactPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Adverse Circumstances in Family of Origin</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_1' name='cbAdverseFoo_1' className='add-only' value='Na' /> N/A</td>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_2' name='cbAdverseFoo_2' className='add-only' value='Poverty' /> Poverty</td>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_3' name='cbAdverseFoo_3' className='add-only' value='CriminalBehavior' /> Criminal Behavior</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_4' name='cbAdverseFoo_4' className='add-only' value='MentalIllness' /> Mental Illness</td>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_5' name='cbAdverseFoo_5' className='add-only' value='SubstanceUse' /> Substance Use</td>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_6' name='cbAdverseFoo_6' className='add-only' value='Abuse' /> Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_7' name='cbAdverseFoo_7' className='add-only' value='Neglect' /> Neglect</td>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_8' name='cbAdverseFoo_8' className='add-only' value='DomesticViolence' /> Domestic Violence</td>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_9' name='cbAdverseFoo_9' className='add-only' value='Violence' /> Violence</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_10' name='cbAdverseFoo_10' className='add-only' value='Trauma' /> Trauma</td>
                        <td className='w-250'><input type='checkbox' id='cbAdverseFoo_11' name='cbAdverseFoo_11' className='add-only' value='Divorce' /> Divorce</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAdverseFoo_12' name='cbAdverseFoo_12' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtAdverseFoo_12' name='txtAdverseFoo_12' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Family Stress</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFamStress_1' name='cbFamStress_1' className='add-only' value='LowStress' /> Low Stress</td>
                        <td className='w-250'><input type='checkbox' id='cbFamStress_2' name='cbFamStress_2' className='add-only' value='MildlyStressful' /> Mildly Stressful</td>
                        <td className='w-250'><input type='checkbox' id='cbFamStress_3' name='cbFamStress_3' className='add-only' value='ModeratelyStressful' /> Moderately Stressful</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFamStress_4' name='cbFamStress_4' className='add-only' value='HighlyStressful' /> Highly Stressful</td>
                        <td className='w-250'><input type='checkbox' id='cbFamStress_5' name='cbFamStress_5' className='add-only' value='ExtremelyStressful' /> Extremely Stressful</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamStress_6' name='cbFamStress_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtFamStress_6' name='txtFamStress_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Family Supports</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFamSupports_1' name='cbFamSupports_1' className='add-only' value='HighlySupportive' /> Highly Supportive</td>
                        <td className='w-250'><input type='checkbox' id='cbFamSupports_2' name='cbFamSupports_2' className='add-only' value='Supportive' /> Supportive</td>
                        <td className='w-250'><input type='checkbox' id='cbFamSupports_3' name='cbFamSupports_3' className='add-only' value='LimitedSupport' /> Limited Support</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFamSupports_4' name='cbFamSupports_4' className='add-only' value='MinimalSupport' /> Minimal Support</td>
                        <td className='w-250'><input type='checkbox' id='cbFamSupports_5' name='cbFamSupports_5' className='add-only' value='NoSupport' /> No Support</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamSupports_6' name='cbFamSupports_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtFamSupports_6' name='txtFamSupports_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <textarea id='txtFamComments' name='txtFamComments' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Trauma History</h4></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Trauma</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTraumaHx_1' name='cbTraumaHx_1' className='add-only' value='None' /> None</td>
                        <td className='w-250'><input type='checkbox' id='cbTraumaHx_2' name='cbTraumaHx_1' className='add-only' value='Experienced' /> Experienced</td>
                        <td className='w-250'><input type='checkbox' id='cbTraumaHx_3' name='cbTraumaHx_1' className='add-only' value='Witnessed' /> Witnessed</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTraumaHx_4' name='cbTraumaHx_4' className='add-only' value='Abuse' /> Abuse</td>
                        <td className='w-250'><input type='checkbox' id='cbTraumaHx_5' name='cbTraumaHx_5' className='add-only' value='Neglect' /> Neglect</td>
                        <td className='w-250'><input type='checkbox' id='cbTraumaHx_6' name='cbTraumaHx_6' className='add-only' value='Violence' /> Violence</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTraumaHx_7' name='cbTraumaHx_7' className='add-only' value='SexualAssault' /> Sexual Assault</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTraumaHx_8' name='cbTraumaHx_8' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtTraumaHx_8' name='txtTraumaHx_8' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Living Situation</h4></p>
                <p className='w-750'><h5>Current status and functioning</h5></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Primary Residence</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPrimaryReside_1' name='cbPrimaryReside_1' className='add-only' value='OwnHome' /> Own Home</td>
                        <td className='w-250'><input type='checkbox' id='cbPrimaryReside_2' name='cbPrimaryReside_2' className='add-only' value='Apartment' /> Apartment</td>
                        <td className='w-250'><input type='checkbox' id='cbPrimaryReside_3' name='cbPrimaryReside_3' className='add-only' value='RelativeHome' /> Relative's Home</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPrimaryReside_4' name='cbPrimaryReside_4' className='add-only' value='GroupHome' /> Group Home</td>
                        <td className='w-250'><input type='checkbox' id='cbPrimaryReside_5' name='cbPrimaryReside_5' className='add-only' value='Homeless' /> Homeless</td>
                        <td className='w-250'><input type='checkbox' id='cbPrimaryReside_6' name='cbPrimaryReside_6' className='add-only' value='LivingWithFriendAcquaintance' /> Living with friend/acquaintance</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPrimaryReside_7' name='cbPrimaryReside_7' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtOther_7' name='txtOther_7' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How long at current residence?</span>
                            <input type='text' id='txtLongCurrReside' name='txtLongCurrReside' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Level of time in community of residence?</span>
                            <input type='text' id='txtTimeCommReside' name='txtTimeCommReside' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Family/Household Composition</span>
                            <input type='text' id='txtFamilyComp' name='txtFamilyComp' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Source of meals/food</span>
                            <input type='text' id='txtFoodSource' name='txtFoodSource' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Means of transportation</span>
                            <input type='text' id='txtPrimaryReside_7' name='txtPrimaryReside_7' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <span className='small'>(Include psychological and social adjustments made to disabilities and/or disorders.)</span>
                    <textarea id='txtLivSitComments' name='txtLivSitComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs</span>
                    <span className='small'>-List what is needed to improve/maintain daily living situation (Ex. Transportation, ability to cook independently, housing subsidy, money in savings, care-giver resource assessment, etc.)</span>
                    <textarea id='txtNeeds' name='txtNeeds' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Preferences</span>
                    <span className='small'>Include things recipient feels will enhance his/her living situation.</span>
                    <textarea id='txtPreferences' name='txtPreferences' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths</span>
                    <span className='small'>List assets, service options, and resources the person has to meet needs, including available housing options. (Ex. Knows area, applied for housing subsidy, can live with family member, unpaid care-giver resource available, etc.)</span>
                    <textarea id='txtStrengths' name='txtStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities/Interests</span>
                    <span className='small'>Include recipient reported skills, aptitudes, capabilities, talents & competencies that might assist in maintaining or improving living situation.</span>
                    <textarea id='txtAbilities' name='txtAbilities' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Learning/Working and Functional Status</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Source of Income</span>
                            <input type='text' id='txtCurrSourceIncome' name='txtCurrSourceIncome' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Estimated Monthly Income Amount</span>
                            <input type='text' id='txtEstIncome' name='txtEstIncome' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Highest Grade or Completed/Degree</span>
                            <input type='text' id='txtHighGrade' name='txtHighGrade' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Military Status</span>
                            <input type='text' id='txtMilitaryStatus' name='txtMilitaryStatus' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Military Trauma</span>
                            <input type='radio' id='rbMilitaryTrauma_Yes' name='rbMilitaryTrauma' className='add-only' value='yes' /> Yes &nbsp;
                            <input type='radio' id='rbMilitaryTrauma_No' name='rbMilitaryTrauma' className='add-only' value='no' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Difficulties with Reading/Writing</span>
                            <input type='radio' id='rbRWDiff_Yes' name='rbRWDiff' className='add-only' value='yes' /> Yes &nbsp;
                            <input type='radio' id='rbRWDiff_No' name='rbRWDiff' className='add-only' value='no' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Estimated Literacy Level</span>
                            <input type='text' id='txtEstLitLevel' name='txtEstLitLevel' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Employment Status</span>
                            <input type='text' id='txtCurrentEmpStatus' name='txtCurrentEmpStatus' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Assistive Devices utilized/required:</span>
                            <input type='radio' id='rbAssistDev_Yes' name='rbAssistDev' className='add-only' value='yes' /> Yes &nbsp;
                            <input type='radio' id='rbAssistDev_No' name='rbAssistDev' className='add-only' value='no' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <span className='small'>(Include psychological and social adjustments made to disabilities and/or disorders.)</span>
                    <textarea id='txtEmpAddComments' name='txtEmpAddComments' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Functional Status Impairment Rating</span>
                            <span className='small'>Assess ability to fulfill responsibilities, interact with others, capacity self-care, missed activities, work or school due to health, etc. (From LOCUS Functional Status Evaluation Parameters.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFSir_1' name='cbFSir_1' className='add-only' value='Minimal' /> Minimal</td>
                        <td className='w-250'><input type='checkbox' id='cbFSir_2' name='cbFSir_2' className='add-only' value='Mild' /> Mild</td>
                        <td className='w-250'><input type='checkbox' id='cbFSir_3' name='cbFSir_3' className='add-only' value='Moderate' /> Moderate</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFSir_4' name='cbFSir_4' className='add-only' value='Serious' /> Serious</td>
                        <td className='w-250'><input type='checkbox' id='cbFSir_5' name='cbFSir_5' className='add-only' value='Extreme' /> Extreme</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>As Evidenced By</span>
                    <textarea id='txtEvidencedBy' name='txtEvidencedBy' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs</span>
                    <span className='small'>List what is needed to improve/maintain income, employment, education, vocational skills, etc. (Ex. Financial support, new skills, training, education, etc.)</span>
                    <textarea id='txtEmpNeeds' name='txtEmpNeeds' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Problems With Basic Needs</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbBasicNeedProblems_1' name='cbBasicNeedProblems_1' className='add-only' value='Food' /> Food</td>
                        <td className='w-250'><input type='checkbox' id='cbBasicNeedProblems_2' name='cbBasicNeedProblems_2' className='add-only' value='Shelter' /> Shelter</td>
                        <td className='w-250'><input type='checkbox' id='cbBasicNeedProblems_3' name='cbBasicNeedProblems_3' className='add-only' value='Clothing' /> Clothing</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbBasicNeedProblems_4' name='cbBasicNeedProblems_4' className='add-only' value='Funds' /> Funds</td>
                        <td className='w-250'><input type='checkbox' id='cbBasicNeedProblems_5' name='cbBasicNeedProblems_5' className='add-only' value='Healthcare' /> Healthcare</td>
                        <td className='w-250'><input type='checkbox' id='cbBasicNeedProblems_6' name='cbBasicNeedProblems_6' className='add-only' value='Adls' /> ADLs</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBasicNeedProblems_7' name='cbBasicNeedProblems_7' className='add-only' value='Other' /> Other:
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <textarea id='txtBasicNeedProblems_7' name='txtBasicNeedProblems_7' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences</span>
                    <span className='small'>Include things recipient feels will enhance functional status with regard to income, employment, learning, literacy, etc.</span>
                    <textarea id='txtEduPreferences' name='txtEduPreferences' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths</span>
                    <span className='small'>List assets, service options, skills & resources recipient has to meet needs. (Ex. Intelligent, motivated, supportive family, education, job experience, interest in furthering education or vocational status, etc.)</span>
                    <textarea id='txtEduStrengths' name='txtEduStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities/Interests</span>
                    <span className='small'>Include recipient reported skills, aptitudes, capabilities, talents & competencies that might assist in maintaining or improving functional status.</span>
                    <textarea id='txtEduAbilities' name='txtEduAbilities' className='add-only'></textarea>
                </p>
                <h4>Social History and Community Integration</h4>
                <p className='w-750'>
                    <span className='eleHeader'>Does Recipient feel supported by friends or family?</span>
                    <input type='radio' id='rbFeelSupported_Yes' name='rbFeelSupported' className='add-only' value='yes' /> Yes &nbsp;
                    <input type='radio' id='rbFeelSupported_No' name='rbFeelSupported' className='add-only' value='no' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Recreational Activities</span>
                    <textarea id='txtRecActivities' name='txtRecActivities' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Self-Help Activities</span>
                    <textarea id='txtSelfActivities' name='txtSelfActivities' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <span className='small'>(Include psychological and social adjustments made to disabilities and/or disorders.)</span>
                    <textarea id='txtActivitiesComments' name='txtActivitiesComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs</span>
                    <span className='small'>List what is needed to improve/maintain recreation, social functioning & community integration. (Ex. Meet new people, painting supplies, sports team, improve family relationships etc.)</span>
                    <textarea id='txtSocNeeds' name='txtSocNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences</span>
                    <span className='small'>Include things recipient feels will enhance or stimulate recreational interests, social functioning & community integration.</span>
                    <textarea id='txtSocPref' name='txtSocPref' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths</span>
                    <span className='small'>List assets, service options & skills that may enhance socialization & community integration. (Ex. Friendly, athletic, independent, friend plays, paints, past history of compliance in treatment, signs of resilience despite past adversity, etc.)</span>
                    <textarea id='txtSocStrengths' name='txtSocStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities/Interests</span>
                    <span className='small'>Include recipient reported skills, aptitudes, talents & competencies that may help maintain or improve socialization & community functioning.</span>
                    <textarea id='txtSocAbilities' name='txtSocAbilities' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Current Status</h2></p>
                <p className='w-750'><h4>Mental Status Exam</h4></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>General Appearance</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbGa_1' name='cbGa_1' className='add-only' value='Healthy' /> Healthy</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_2' name='cbGa_2' className='add-only' value='AsStatedAge' /> As Stated Age</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_3' name='cbGa_3' className='add-only' value='OlderThanStatedAge' /> Older Than Stated Age</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbGa_4' name='cbGa_4' className='add-only' value='Healthy' /> Healthy</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_5' name='cbGa_5' className='add-only' value='AsStatedAge' /> As Stated Age</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_6' name='cbGa_6' className='add-only' value='OlderThanStatedAge' /> Older Than Stated Age</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbGa_7' name='cbGa_7' className='add-only' value='Young-Looking' /> Young-looking</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_8' name='cbGa_8' className='add-only' value='Tattoos' /> Tattoos</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_9' name='cbGa_9' className='add-only' value='Disheveled' /> Disheveled</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbGa_10' name='cbGa_10' className='add-only' value='Unkempt' /> Unkempt</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_11' name='cbGa_11' className='add-only' value='Malodorous' /> Malodorous</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_12' name='cbGa_12' className='add-only' value='Thin' /> Thin</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbGa_13' name='cbGa_13' className='add-only' value='Overweight' /> Overweight</td>
                        <td className='w-250'><input type='checkbox' id='cbGa_14' name='cbGa_14' className='add-only' value='Obese' /> Obese</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGa_15' name='cbGa_15' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtGa_15' name='txtGa_15' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Behavior & Psychomotor Activity</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbBxPa_1' name='cbBxPa_1' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-250'><input type='checkbox' id='cbBxPa_2' name='cbBxPa_2' className='add-only' value='Overactive' /> Overactive</td>
                        <td className='w-250'><input type='checkbox' id='cbBxPa_3' name='cbBxPa_3' className='add-only' value='Hypoactive' /> Hypoactive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbBxPa_4' name='cbBxPa_4' className='add-only' value='Catatonia' /> Catatonia</td>
                        <td className='w-250'><input type='checkbox' id='cbBxPa_5' name='cbBxPa_5' className='add-only' value='Tremor' /> Tremor</td>
                        <td className='w-250'><input type='checkbox' id='cbBxPa_6' name='cbBxPa_6' className='add-only' value='Tics' /> Tics</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbBxPa_7' name='cbBxPa_7' className='add-only' value='Combative' /> Combative</td>
                        <td className='w-250'><input type='checkbox' id='cbBxPa_8' name='cbBxPa_8' className='add-only' value='AbnormalGait' /> Abnormal Gait</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBxPa_9' name='cbBxPa_9' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtBxPa_9' name='txtBxPa_9' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Attitude</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAtt_1' name='cbAtt_1' className='add-only' value='Optimal' /> Optimal</td>
                        <td className='w-250'><input type='checkbox' id='cbAtt_2' name='cbAtt_2' className='add-only' value='Constructive' /> Constructive</td>
                        <td className='w-250'><input type='checkbox' id='cbAtt_3' name='cbAtt_3' className='add-only' value='Motivated' /> Motivated</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAtt_4' name='cbAtt_4' className='add-only' value='Obstructive' /> Obstructive</td>
                        <td className='w-250'><input type='checkbox' id='cbAtt_5' name='cbAtt_5' className='add-only' value='Adversarial' /> Adversarial</td>
                        <td className='w-250'><input type='checkbox' id='cbAtt_6' name='cbAtt_6' className='add-only' value='Inaccessible' /> Inaccessible</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAtt_7' name='cbAtt_7' className='add-only' value='Cooperative' /> Cooperative</td>
                        <td className='w-250'><input type='checkbox' id='cbAtt_8' name='cbAtt_8' className='add-only' value='Seductive' /> Seductive</td>
                        <td className='w-250'><input type='checkbox' id='cbAtt_9' name='cbAtt_9' className='add-only' value='Defensive' /> Defensive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAtt_10' name='cbAtt_10' className='add-only' value='Hostile' /> Hostile</td>
                        <td className='w-250'><input type='checkbox' id='cbAtt_11' name='cbAtt_11' className='add-only' value='Guarded' /> Guarded</td>
                        <td className='w-250'><input type='checkbox' id='cbAtt_12' name='cbAtt_12' className='add-only' value='Apathetic' /> Apathetic</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAtt_13' name='cbAtt_13' className='add-only' value='Evasive' /> Evasive</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAtt_14' name='cbAtt_14' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtAtt_14' name='txtAtt_14' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Speech</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Spontaneous' /> Spontaneous</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Slow' /> Slow</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Impoverished' /> Impoverished</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Hesitant' /> Hesitant</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_6' name='cbSpeech_6' className='add-only' value='Monotonous' /> Monotonous</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_7' name='cbSpeech_7' className='add-only' value='SoftWhispered' /> Soft/Whispered</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_8' name='cbSpeech_8' className='add-only' value='Mumbled' /> Mumbled</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_9' name='cbSpeech_9' className='add-only' value='Rapid' /> Rapid</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_10' name='cbSpeech_10' className='add-only' value='Pressured' /> Pressured</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_11' name='cbSpeech_11' className='add-only' value='Verbose' /> Verbose</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_12' name='cbSpeech_12' className='add-only' value='Loud' /> Loud</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_13' name='cbSpeech_13' className='add-only' value='Slurred' /> Slurred</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_14' name='cbSpeech_14' className='add-only' value='Impediment' /> Impediment</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSpeech_15' name='cbSpeech_15' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtSpeech_15' name='txtSpeech_15' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Mood</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='Dysphoric' /> Dysphoric</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Euthymic' /> Euthymic</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_3' name='cbMood_3' className='add-only' value='Expansive' /> Expansive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Irritable' /> Irritable</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Labile' /> Labile</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Elevated' /> Elevated</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_7' name='cbMood_7' className='add-only' value='Euphoric' /> Euphoric</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_8' name='cbMood_8' className='add-only' value='Ecstatic' /> Ecstatic</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_9' name='cbMood_9' className='add-only' value='Depressed' /> Depressed</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_10' name='cbMood_10' className='add-only' value='GriefMouring' /> Grief/Mouring</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_11' name='cbMood_11' className='add-only' value='Alexithymic' /> Alexithymic</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_12' name='cbMood_12' className='add-only' value='Elated' /> Elated</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_13' name='cbMood_13' className='add-only' value='Hypomaniac' /> Hypomaniac</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_14' name='cbMood_14' className='add-only' value='Manic' /> Manic</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_15' name='cbMood_15' className='add-only' value='Anxious' /> Anxious</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_16' name='cbMood_16' className='add-only' value='Tense' /> Tense</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMood_17' name='cbMood_17' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtMood_17' name='txtMood_17' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Affect</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Inappropriate' /> Inappropriate</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Blunted' /> Blunted</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Restricted' /> Restricted</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='Flat' /> Flat</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_6' name='cbAffect_6' className='add-only' value='Labile' /> Labile</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffect_7' name='cbAffect_7' className='add-only' value='Tearful' /> Tearful</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_8' name='cbAffect_8' className='add-only' value='Intense' /> Intense</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAffect_9' name='cbAffect_9' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtAffect_9' name='txtAffect_9' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Perceptual Disturbances</span></p>

                <table>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPd_0' name='cbPd_0' className='add-only' value='Na' /> NA</td>
                        <td className='w-250'><input type='checkbox' id='cbPd_1' name='cbPd_1' className='add-only' value='None' /> None</td>
                        <td className='w-250'><input type='checkbox' id='cbPd_2' name='cbPd_2' className='add-only' value='AuditoryHallucinations' /> Auditory Hallucinations</td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPd_3' name='cbPd_3' className='add-only' value='Visual Hallucinations' /> Visual Hallucinations</td>
                        <td className='w-250'><input type='checkbox' id='cbPd_4' name='cbPd_4' className='add-only' value='Olfactory Hallucinations' /> Olfactory Hallucinations</td>
                        <td className='w-250'><input type='checkbox' id='cbPd_5' name='cbPd_5' className='add-only' value='Tactile Hallucinations' /> Tactile Hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPd_6' name='cbPd_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtPd_6' name='txtPd_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Thought Process</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTp_1' name='cbTp_1' className='add-only' value='LogicalCoherent' /> Logical/Coherent</td>
                        <td className='w-250'><input type='checkbox' id='cbTp_2' name='cbTp_2' className='add-only' value='Incomprehensible' /> Incomprehensible</td>
                        <td className='w-250'><input type='checkbox' id='cbTp_3' name='cbTp_3' className='add-only' value='Incoherent' /> Incoherent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTp_4' name='cbTp_4' className='add-only' value='FlightIdeas' /> Flight of Ideas</td>
                        <td className='w-250'><input type='checkbox' id='cbTp_5' name='cbTp_5' className='add-only' value='LooseAssociations' /> Loose Associations</td>
                        <td className='w-250'><input type='checkbox' id='cbTp_6' name='cbTp_6' className='add-only' value='Tangential' /> Tangential</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTp_7' name='cbTp_7' className='add-only' value='Circumstantial' /> Circumstantial</td>
                        <td className='w-250'><input type='checkbox' id='cbTp_8' name='cbTp_8' className='add-only' value='Rambling' /> Rambling</td>
                        <td className='w-250'><input type='checkbox' id='cbTp_9' name='cbTp_9' className='add-only' value='Evasive' /> Evasive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTp_10' name='cbTp_10' className='add-only' value='RacingThoughts' /> Racing Thoughts</td>
                        <td className='w-250'><input type='checkbox' id='cbTp_11' name='cbTp_11' className='add-only' value='Perseveration' /> Perseveration</td>
                        <td className='w-250'><input type='checkbox' id='cbTp_12' name='cbTp_12' className='add-only' value='ThoughtBlocking' /> Thought Blocking</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTp_13' name='cbTp_13' className='add-only' value='Concrete' /> Concrete</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTp_14' name='cbTp_14' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtTp_14' name='txtTp_14' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Thought Content</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTc_1' name='cbTc_1' className='add-only' value='Preoccupations' /> Preoccupations</td>
                        <td className='w-250'><input type='checkbox' id='cbTc_2' name='cbTc_2' className='add-only' value='Obsessions' /> Obsessions</td>
                        <td className='w-250'><input type='checkbox' id='cbTc_3' name='cbTc_3' className='add-only' value='Compulsions' /> Compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTc_4' name='cbTc_4' className='add-only' value='Phobias' /> Phobias</td>
                        <td className='w-250'><input type='checkbox' id='cbTc_5' name='cbTc_5' className='add-only' value='Delusions' /> Delusions</td>
                        <td className='w-250'><input type='checkbox' id='cbTc_6' name='cbTc_6' className='add-only' value='ThoughtBroadcasting' /> Thought Broadcasting</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTc_7' name='cbTc_7' className='add-only' value='ThoughtInsertion' /> Thought Insertion</td>
                        <td className='w-250'><input type='checkbox' id='cbTc_8' name='cbTc_8' className='add-only' value='ThoughtWithdrawal' /> Thought Withdrawal</td>
                        <td className='w-250'><input type='checkbox' id='cbTc_9' name='cbTc_9' className='add-only' value='IdeasReference' /> Ideas of Reference</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTc_10' name='cbTc_10' className='add-only' value='IdeasInfluence' /> Ideas of Influence</td>
                        <td className='w-250'><input type='checkbox' id='cbTc_11' name='cbTc_11' className='add-only' value='Delusions' /> Delusions</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTc_12' name='cbTc_12' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtTc_12' name='txtTc_12' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Suicidal/Homicidal Ideation</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbShi_Nr' name='cbShi_Nr' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbShi_Ni' name='cbShi_Ni' className='add-only' value='NoneIdentified' /> None Identified</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbShi_1' name='cbShi_1' className='add-only' value='SuicideThoughts' /> Suicide Thoughts</td>
                        <td className='w-250'><input type='checkbox' id='cbShi_2' name='cbShi_2' className='add-only' value='SuicideAttempts' /> Suicide Attempts</td>
                        <td className='w-250'><input type='checkbox' id='cbShi_3' name='cbShi_3' className='add-only' value='SuicidalIntent' /> Suicidal Intent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbShi_4' name='cbShi_4' className='add-only' value='SuicidalPlans' /> Suicidal Plans</td>
                        <td className='w-250'><input type='checkbox' id='cbShi_5' name='cbShi_5' className='add-only' value='HistorySelf' /> History of Self-Injurious Behavior</td>
                        <td className='w-250'><input type='checkbox' id='cbShi_6' name='cbShi_6' className='add-only' value='HomicidalThoughts' /> Homicidal Thoughts</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbShi_7' name='cbShi_7' className='add-only' value='HomicidalAttempts' /> Homicidal Attempts</td>
                        <td className='w-250'><input type='checkbox' id='cbShi_8' name='cbShi_8' className='add-only' value='HomicidalIntent' /> Homicidal Intent</td>
                        <td className='w-250'><input type='checkbox' id='cbShi_9' name='cbShi_9' className='add-only' value='HomicidalPlans' /> Homicidal Plans</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbShi_10' name='cbShi_10' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtShi_10' name='txtShi_10' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Sensorium/Cognition</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSc_1' name='cbSc_1' className='add-only' value='Alert' /> Alert</td>
                        <td className='w-250'><input type='checkbox' id='cbSc_2' name='cbSc_2' className='add-only' value='Lethargic' /> Lethargic</td>
                        <td className='w-250'><input type='checkbox' id='cbSc_3' name='cbSc_3' className='add-only' value='Somnolent' /> Somnolent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSc_4' name='cbSc_4' className='add-only' value='Stuporous' /> Stuporous</td>
                        <td className='w-250'><input type='checkbox' id='cbSc_5' name='cbSc_5' className='add-only' value='OrientedPerson' /> Oriented to Person</td>
                        <td className='w-250'><input type='checkbox' id='cbSc_6' name='cbSc_6' className='add-only' value='OrientedPlace' /> Oriented to Place</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSc_7' name='cbSc_7' className='add-only' value='OrientedTime' /> Oriented to Time</td>
                        <td className='w-250'><input type='checkbox' id='cbSc_8' name='cbSc_8' className='add-only' value='OrientedSituation' /> Oriented to Situation</td>
                        <td className='w-250'><input type='checkbox' id='cbSc_9' name='cbSc_9' className='add-only' value='Normal Concentration' /> Normal Concentration</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSc_10' name='cbSc_10' className='add-only' value='ImpairedConcentration' /> Impaired Concentration</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSc_11' name='cbSc_11' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtSc_11' name='txtSc_11' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Remote Memory</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRemMem_1' name='cbRemMem_1' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-250'><input type='checkbox' id='cbRemMem_2' name='cbRemMem_2' className='add-only' value='Impaired' /> Impaired</td>
                    </tr>
                </table>
                <span className='eleHeader'>Recent Memory</span>
                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRecMem_1' name='cbRecMem_1' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-250'><input type='checkbox' id='cbRecMem_2' name='cbRecMem_2' className='add-only' value='Impaired' /> Impaired</td>
                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>Immediate Recall</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIr_1' name='cbIr_1' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-250'><input type='checkbox' id='cbIr_2' name='cbIr_2' className='add-only' value='Impaired' /> Impaired</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIr_3' name='cbIr_3' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtIr_3' name='txtIr_3' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Intellectual Functioning</span></p>
                <p className='w-750'><span className='small'>(estimate)</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIf_1' name='cbIf_1' className='add-only' value='AboveAverage' /> Above Average</td>
                        <td className='w-250'><input type='checkbox' id='cbIf_2' name='cbIf_2' className='add-only' value='NormalAverage' /> Normal/Average</td>
                        <td className='w-250'><input type='checkbox' id='cbIf_3' name='cbIf_3' className='add-only' value='Borderline' /> Borderline</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Intellectual Disability</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbId_1' name='cbId_1' className='add-only' value='Mild' /> Mild</td>
                        <td className='w-250'><input type='checkbox' id='cbId_2' name='cbId_2' className='add-only' value='Moderate' /> Moderate</td>
                        <td className='w-250'><input type='checkbox' id='cbId_3' name='cbId_3' className='add-only' value='Severe' /> Severe</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbId_4' name='cbId_4' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtId_4' name='txtId_4' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Judgment</span></p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbJudg_1' name='cbJudg_1' className='add-only' value='CriticalJudgmentIntact' /> Critical Judgment Intact</td>
                        <td className='w-375'><input type='checkbox' id='cbJudg_2' name='cbJudg_2' className='add-only' value='ImpairedJudgment' /> Impaired Judgment</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbJudg_3' name='cbJudg_3' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtJudg_3' name='txtJudg_3' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Insight</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIns_1' name='cbIns_1' className='add-only' value='TrueEmotionalInsight' /> True Emotional Insight</td>
                        <td className='w-250'><input type='checkbox' id='cbIns_2' name='cbIns_2' className='add-only' value='IntellectualInsight' /> Intellectual Insight</td>
                        <td className='w-250'><input type='checkbox' id='cbIns_3' name='cbIns_3' className='add-only' value='SomeAwarenessIllnessSymptoms' /> Some Awareness of Illness/Symptoms</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIns_4' name='cbIns_4' className='add-only' value='ImpairedInsight' /> Impaired Insight</td>
                        <td className='w-250'><input type='checkbox' id='cbIns_5' name='cbIns_5' className='add-only' value='Denial' /> Denial</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIns_6' name='cbIns_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtIns_6' name='txtIns_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Impulse Control</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIc_1' name='cbIc_1' className='add-only' value='AbleResistImpulses' /> Able to Resist Impulses</td>
                        <td className='w-250'><input type='checkbox' id='cbIc_2' name='cbIc_2' className='add-only' value='RecentImpulsiveBehavior' /> Recent Impulsive Behavior</td>
                        <td className='w-250'><input type='checkbox' id='cbIc_3' name='cbIc_3' className='add-only' value='ImpairedImpulseControl' /> Impaired Impulse Control</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIc_4' name='cbIc_4' className='add-only' value='Compulsions' /> Compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIc_5' name='cbIc_5' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtIc_5' name='txtIc_5' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Risk Assessment</h4></p>
                <p className='w-750'><h5>Assess potential risk of harm to self or others, including patterns of risk behavior
                    and/or risk due to personality factors, substance use, criminogenic factors, exposure to elements, exploitation,
                    abuse, neglect, suicidal or homicidal history, self-injury, psychosis, impulsiveness, etc.</h5></p>

                <p className='w-750'><span className='eleHeader'>Risk of Harm to Self</span></p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRhs_Nr' name='cbRhs_Nr' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-375'><input type='checkbox' id='cbRhs_Ni' name='cbRhs_Ni' className='add-only' value='NoneIdentified' /> None Identified</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRhs_1' name='cbRhs_1' className='add-only' value='PriorSuicideAttempt' /> Prior Suicide Attempt</td>
                        <td className='w-375'><input type='checkbox' id='cbRhs_2' name='cbRhs_2' className='add-only' value='StatedPlanIntent' /> Stated Plan/Intent</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRhs_3' name='cbRhs_3' className='add-only' value='AccessMeans' /> Access to means (weapons, pills, etc.)</td>
                        <td className='w-375'><input type='checkbox' id='cbRhs_4' name='cbRhs_4' className='add-only' value='RecentLoss' /> Recent Loss</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRhs_7' name='cbRhs_7' className='add-only' value='TerminalIllness' /> Terminal Illness</td>
                        <td className='w-375'><input type='checkbox' id='cbRhs_6' name='cbRhs_6' className='add-only' value='FamilyHistorySuicide' /> Family History of Suicide</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRhs_8' name='cbRhs_8' className='add-only' value='SubstanceAbuse' /> Substance Abuse</td>
                        <td className='w-375'><input type='checkbox' id='cbRhs_9' name='cbRhs_9' className='add-only' value='MarkedLackSupport' /> Marked lack of support</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRhs_10' name='cbRhs_10' className='add-only' value='Psychosis' /> Psychosis</td>
                        <td className='w-375'><input type='checkbox' id='cbRhs_11' name='cbRhs_11' className='add-only' value='SuicideFriendAcquaintance' /> Suicide of friend/acquaintance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRhs_5' name='cbRhs_5' className='add-only' value='PresenceBehavioralCues' /> Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings, etc.)</td></tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRhs_12' name='cbRhs_12' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtRhs_12' name='txtRhs_12' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Risk of Harm to Others</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRho_Nr' name='cbRho_Nr' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbRho_Ni' name='cbRho_Ni' className='add-only' value='NoneIdentified' /> None Identified</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRho_1' name='cbRho_1' className='add-only' value='PriorSuicideAttempt' /> Prior Acts of Violence</td>
                        <td className='w-500'>If yes, when was most recent violent act? &nbsp;
                            <input type='text' id='txtRho_Recent' name='txtRho_Recent' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRho_2' name='cbRho_2' className='add-only' value='DestructionProperty' /> Destruction of property</td>
                        <td className='w-250'><input type='checkbox' id='cbRho_3' name='cbRho_3' className='add-only' value='ArrestsViolence' /> Arrests for violence</td>
                        <td className='w-250'><input type='checkbox' id='cbRho_4' name='cbRho_4' className='add-only' value='AccessMeans' /> Access to means (weapons)</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRho_5' name='cbRho_5' className='add-only' value='SubstanceUse' /> Substance use</td>
                        <td className='w-250'><input type='checkbox' id='cbRho_6' name='cbRho_6' className='add-only' value='PhysicallyAbusedChild' /> Physically abused as child</td>
                        <td className='w-250'><input type='checkbox' id='cbRho_7' name='cbRho_7' className='add-only' value='WasPhysicallyAbusiveChild' /> Was physically abusive as a child</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRho_8' name='cbRho_8' className='add-only' value='HarmsAnimals' /> Harms animals</td>
                        <td className='w-250'><input type='checkbox' id='cbRho_9' name='cbRho_9' className='add-only' value='FireSetting' /> Fire setting</td>
                        <td className='w-250'><input type='checkbox' id='cbRho_10' name='cbRho_10' className='add-only' value='AngryMoodAgitation' /> Angry mood/agitation</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='checkbox' id='cbRho_12' name='cbRho_12' className='add-only' value='Psychosis' /> Psychosis/command hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRho_11' name='cbRho_11' className='add-only' value='PriorHospitalizationsDangerOthers' /> Prior hospitalizations for danger to others</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            If yes, is there history of acting on any commands to harm others? &nbsp;
                            <input type='radio' id='rbRho_12_Yes' name='rbRho_12' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbRho_12_No' name='rbRho_12' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRho_13' name='cbRho_13' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtRho_13' name='txtRho_13' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Risk of Harm to Self or Others Rating</span></p>
                <p className='w-750'><span className='small'>(From LOCUS Risk of Harm Evaluation Parameters.)</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRhr_1' name='cbRhr_1' className='add-only' value='Minimal' /> Minimal</td>
                        <td className='w-250'><input type='checkbox' id='cbRhr_2' name='cbRhr_2' className='add-only' value='Low' /> Low</td>
                        <td className='w-250'><input type='checkbox' id='cbRhr_3' name='cbRhr_3' className='add-only' value='Moderate' /> Moderate</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRhr_4' name='cbRhr_4' className='add-only' value='Serious' /> Serious</td>
                        <td className='w-250'><input type='checkbox' id='cbRhr_5' name='cbRhr_5' className='add-only' value='Extreme' /> Extreme</td>
                        <td>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>As Evidenced By</span>
                    <textarea id='txtRhr_AsEvidencedBy' name='txtRhr_AsEvidencedBy' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Recipient Safety & Other Risk Factors</span></p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRsorf_Nr' name='cbRsorf_Nr' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-375'><input type='checkbox' id='cbRsorf_Ni' name='cbRsorf_Ni' className='add-only' value='NoneIdentified' /> None Identified</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRsorf_1' name='cbRsorf_1' className='add-only' value='FeelsUnsafeCurrentLivingEnvironment' /> Feels unsafe in current living environment</td>
                        <td className='w-375'><input type='checkbox' id='cbRsorf_7' name='cbRsorf_7' className='add-only' value='RelapseDecompensationTriggers' /> Relapse/decompensation triggers</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRsorf_3' name='cbRsorf_3' className='add-only' value='FeelsSnsafeCurrentLivingEnvironment' /> Feels unsafe in current living environment</td>
                        <td className='w-375'><input type='checkbox' id='cbRsorf_5' name='cbRsorf_5' className='add-only' value='EngagesDangerousSexualBehavior' /> Engages in dangerous sexual behavior</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRsorf_2' name='cbRsorf_2' className='add-only' value='Serious' /> Feels currently being harmed/hurt/abused/threatened by someone</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRsorf_4' name='cbRsorf_4' className='add-only' value='FeelsCurrentlyBeingSomeone' /> Feels currently being harmed/hurt/abused/threatened by someone</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRsorf_6' name='cbRsorf_6' className='add-only' value='PastInvolvementWithChildAdultProtectiveServices' /> Past involvement with Child or Adult Protective Services</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRsorf_8' name='cbRsorf_8' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtRsorf_8' name='txtRsorf_8' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Cultural & Language Preferences</h4></p>
                <p className='w-750'><h5>(Language, Customs/Values/Preferences)</h5></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Spiritual Beliefs/Preferences:</span>
                            <input type='text' id='txtSpiritualBeliefs' name='txtSpiritualBeliefs' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Cultural Beliefs/Preferences</span>
                            <input type='text' id='txtCulturalBeliefs' name='txtCulturalBeliefs' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h2>Principal Diagnosis</h2></p>
                <p className='w-750'><h5>(Provide principal DSM-V/ICD-10 behavioral and medical diagnoses)</h5></p>

                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Code</span>
                        </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Description</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtCode_1' name='txtCode_1' className='add-only' /></td>
                        <td className='w-600'><input type='text' id='txtDesc_1' name='txtDesc_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtCode_2' name='txtCode_2' className='add-only' /></td>
                        <td className='w-600'><input type='text' id='txtDesc_2' name='txtDesc_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtCode_3' name='txtCode_3' className='add-only' /></td>
                        <td className='w-600'><input type='text' id='txtDesc_3' name='txtDesc_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtCode_4' name='txtCode_4' className='add-only' /></td>
                        <td className='w-600'><input type='text' id='txtDesc_4' name='txtDesc_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtCode_5' name='txtCode_5' className='add-only' /></td>
                        <td className='w-600'><input type='text' id='txtDesc_5' name='txtDesc_5' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Interpretive Summary</span>
                    <span className='small'>Briefly describe client/member's global preferences/hopes for recovery, your clinical summary, and recommended treatments/assessments, level of care, duration.</span>
                    <textarea id='txtInterpretiveSumm' name='txtInterpretiveSumm' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Recommended Services</span></p>
                <p className='w-750'><span className='small'>Check all that apply</span></p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_Mts' name='cbRecSvcs_Mts' className='add-only' value='MedicationTrainingSupport)' /> MTS (Medication Training & Support)</td>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_Tcm' name='cbRecSvcs_Tcm' className='add-only' value='TargetedCaseManagement)' /> TCM (Targeted Case Management)</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_Sktd' name='cbRecSvcs_Sktd' className='add-only' value='SkillsTrainingDevelopment)' /> SKTD (Skills Training & Development)</td>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_Ci' name='cbRecSvcs_Ci' className='add-only' value='CrisisIntervention)' /> CI (Crisis Intervention) - if necessary</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_1' name='cbRecSvcs_1' className='add-only' value='FamilyTherapy' /> Family Therapy</td>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_2' name='cbRecSvcs_2' className='add-only' value='IndividualTherapy' /> Individual Therapy</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_3' name='cbRecSvcs_3' className='add-only' value='GroupTherapy' /> Group Therapy</td>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_4' name='cbRecSvcs_4' className='add-only' value='AlcoholDrugAssessment' /> Alcohol/Drug Assessment</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_6' name='cbRecSvcs_6' className='add-only' value='Psr' /> PSR</td>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_7' name='cbRecSvcs_7' className='add-only' value='Cpst' /> CPST</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecSvcs_5' name='cbRecSvcs_5' className='add-only' value='AlcoholDrugIndividualTherapy' /> Alcohol/ Drug Individual Therapy</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecSvcs_8' name='cbRecSvcs_8' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtRecSvcs_8' name='txtRecSvcs_8' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Other Services/Linkages Needed</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOtherSvcs_1' name='cbOtherSvcs_1' className='add-only' value='VocationalServices' /> Vocational Services</td>
                        <td className='w-250'><input type='checkbox' id='cbOtherSvcs_2' name='cbOtherSvcs_2' className='add-only' value='SocialServices' /> Social Services</td>
                        <td className='w-250'><input type='checkbox' id='cbOtherSvcs_3' name='cbOtherSvcs_3' className='add-only' value='EducationalServices' /> Educational Services</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOtherSvcs_4' name='cbOtherSvcs_4' className='add-only' value='MedicalServicesPcp' /> Medical Services/PCP</td>
                        <td className='w-250'><input type='checkbox' id='cbOtherSvcs_5' name='cbOtherSvcs_5' className='add-only' value='SelfHelpGroups' /> Self help Groups;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOtherSvcs_6' name='cbOtherSvcs_6' className='add-only' value='Other' /> Other: &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtOtherSvcs_6' name='txtOtherSvcs_6' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <textarea id='txtOtherSvcsAddlCommm' name='txtOtherSvcsAddlCommm' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Signature</h2></p>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











